import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'

import '@/styles/globals.css'

import { Providers } from '@/app/providers'
import { createQueryClient } from '@/app/query-client'
import { createAppRouter } from '@/app/router'

/** `VITE_MOCK=1` (npm run dev:mock) serves the API from MSW in the browser; no server needed. */
async function startMocks(): Promise<void> {
  if (import.meta.env.VITE_MOCK !== '1') return
  const { startMockWorker } = await import('@/test/msw/browser')
  await startMockWorker()
}

const queryClient = createQueryClient()
const router = createAppRouter(queryClient)

void startMocks().then(() => {
  const root = document.getElementById('root')
  if (!root) throw new Error('index.html has no #root')
  createRoot(root).render(
    <StrictMode>
      <Providers queryClient={queryClient}>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  )
})
